import { useState } from 'react';
import Tabs from '@cloudscape-design/components/tabs';
import { SafeLinksTab } from '@components/SafeLinksTab';
import { AboutSafeLinksTab } from '@components/AboutSafeLinksTab';

const SafeLinksTool = () => {
  const [activeTabId, setActiveTabId] = useState('decoder');

  return (
    <Tabs
      activeTabId={activeTabId}
      onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
      tabs={[
        {
          id: 'decoder',
          label: 'Decode M365 Safe Links',
          content: <SafeLinksTab />,
        },
        {
          id: 'about',
          label: 'About M365 Safe Links',
          content: <AboutSafeLinksTab />,
        },
      ]}
    />
  );
};

export default SafeLinksTool;

